import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    container: {
      padding: '1rem 3rem',
      marginBottom: '1rem',
    },
    textField: {
      width: '100%',
      marginBottom: '1rem',
    },
    textFieldIsNotEditing: {
      background: theme.palette.common.greyLight,
    },
    textArea: {
      padding: '1rem',
    },
    textareaEmpty: {
      minHeight: '5rem',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '1rem',
      color: theme.palette.text.disabled,
      background: theme.palette.common.greyLight,
    },
    actionMenu: {
      textAlign: 'right',
    },
    editActions: {
      justifyContent: 'flex-end',
    },
    button: {
      minWidth: '6.25rem',
    },
    cancelButton: {
      marginRight: '1rem',
    },
  };
});

export { useStyles };
